import { getProfile, setProfile } from '@/tool/profile';

import {
  PROFILE_LOGIN_REQUEST,
  PROFILE_LOGIN_SUCCESS,
  PROFILE_LOGIN_FAILURE,
  PROFILE_AVATAR_UPDATE,
  PROFILE_MESSAGE_UPDATE,
  PROFILE_QRURL_UPDATE,
  PROFILE_QRENABLED_UPDATE,
} from '../constants/ProfileConstants';

const initialState = {
  // profile: {
  //     // userid: 0,
  //     // username:'',
  //     // deptid : 0,
  //     // deptname : '',
  // },
  profile: getProfile(),
  // profile : {},
  messages: {
    // 待审批的消息数量
    authcount: 0,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case PROFILE_LOGIN_REQUEST: {
      return {
        ...state,
        isLoading: action.isLoading,
      };
    }
    case PROFILE_LOGIN_SUCCESS: {
      const { isLoading, payload } = action;
      return {
        ...state,
        isLoading,
        profile: payload,
      };
    }

    case PROFILE_LOGIN_FAILURE: {
      return {
        ...state,
        isLoading: action.isLoading,
      };
    }

    case PROFILE_AVATAR_UPDATE: {
      return {
        ...state,
        profile: { ...state.profile, avatar: action.payload },
      };
    }

    case PROFILE_MESSAGE_UPDATE: {
      return {
        ...state,
        messages: action.payload,
      };
    }

    case PROFILE_QRURL_UPDATE: {
      setProfile(Object.assign(state.profile, { qrurl: action.payload }));
      return {
        ...state,
        profile: { ...state.profile, qrurl: action.payload },
      };
    }

    case PROFILE_QRENABLED_UPDATE: {
      setProfile(Object.assign(state.profile, { qrenabled: action.payload }));
      return {
        ...state,
        profile: { ...state.profile, qrenabled: action.payload },
      };
    }

    default:
      return state;
  }
}
